import { render, staticRenderFns } from "./customDatepicker.vue?vue&type=template&id=8873007e&"
import script from "./customDatepicker.vue?vue&type=script&lang=js&"
export * from "./customDatepicker.vue?vue&type=script&lang=js&"
import style0 from "./customDatepicker.vue?vue&type=style&index=0&id=8873007e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports